import { z } from "zod";

const phonePattern = /^\+[1-9]\d{6,14}$/;

const optionalPhoneSchema = z.preprocess(
  (value) => {
    if (typeof value !== "string") {
      return value;
    }

    const trimmed = value.trim();
    return trimmed === "" ? undefined : trimmed;
  },
  z
    .string()
    .regex(phonePattern, "auth.validation.phone")
    .optional(),
);

export const registerSchema = z.object({
  first_name: z.string().trim().min(1, "auth.validation.required"),
  last_name: z.string().trim().min(1, "auth.validation.required"),
  email: z.string().trim().email("auth.validation.email"),
  password: z.string().min(8, "auth.validation.passwordLength"),
  phone: optionalPhoneSchema,
});

export const loginSchema = z.object({
  email: z.string().trim().email("auth.validation.email"),
  password: z.string().min(1, "auth.validation.required"),
});

export const forgotPasswordSchema = z.object({
  email: z.string().trim().email("auth.validation.email"),
});

export const resetPasswordSchema = z
  .object({
    password: z.string().min(8, "auth.validation.passwordLength"),
    confirm_password: z.string().min(8, "auth.validation.passwordLength"),
  })
  .refine((data) => data.password === data.confirm_password, {
    message: "auth.validation.passwordMatch",
    path: ["confirm_password"],
  });

export type RegisterFormValues = z.input<typeof registerSchema>;
export type RegisterSubmissionValues = z.output<typeof registerSchema>;
export type LoginFormValues = z.output<typeof loginSchema>;
export type ForgotPasswordFormValues = z.output<typeof forgotPasswordSchema>;
export type ResetPasswordFormValues = z.output<typeof resetPasswordSchema>;
